/**
 * Defines constant logo URLs that might need to be referenced by many components.
 */
export const LOGOS = {
  wordmark: {
    light:
      'https://images.grove.co/upload/v1544488331/global/grove-wordmark-cream.svg',
  },
  icon: {
    light:
      'https://images.grove.co/upload/v1554326506/global/Icons/svg-icons/grove-symbol-white.svg',
  },
}
